import Resource from '@/api/resources/Resource'

class IncidentCoreEntityService extends Resource {
    async getCoreEntities() {
        const response = await this.axios.get(`/incident/coreEntities`)
        return response.data
    }
}

export default new IncidentCoreEntityService()
